import React from "react";
import { RiErrorWarningLine } from "react-icons/ri";
import "./ErrorState.css";

const ErrorState = ({
  title = "Something went wrong",
  description = "We couldn't load this right now.",
  onRetry,
}) => (
  <div className="error-state" role="alert">
    <div className="error-state-icon">
      <RiErrorWarningLine size={28} />
    </div>
    <h3 className="error-state-title">{title}</h3>
    <p className="error-state-desc">{description}</p>
    {onRetry && (
      <button type="button" className="btn btn-primary" onClick={onRetry}>
        Try again
      </button>
    )}
  </div>
);

export default ErrorState;
